const axios = require("axios");

const conceptId = "5f6dad6381a54600172754e7";
const api_root = "https://louisvuitton.carlipa.online/api";

const routes = {
  login: {
    post: () => `/login`,
  },
  devices: {
    get: () => `/devices?query=${encodeURI(`{"concepts":"${conceptId}"}`)}`,
  },
  playlists: {
    get: ({ device_id }) => `/devices/${device_id}/proxy/playlists`,
  },
  thumbnail: {
    get: ({ id }) => `/assets/${id}/thumbnail`,
  },
  trigger: {
    post: ({ device_id }) => `/devices/${device_id}/proxy/playlists/trigger`,
  },
};

const getUrl = ({ type, method, value }) =>
  `${api_root}${routes[type][method](value)}`;

const request = ({
  type,
  method = "GET",
  value,
  isSource = true,
  headers,
  url,
  ...options
}) =>
  axios({
    url: url || getUrl({ type, method, value }),
    method: method.toUpperCase(),
    timeout: 60 * 1000 * 1000,
    maxRedirects: 100,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
      ...headers,
    },
    ...options,
  });

const downloadImage = (url) =>
  axios({
    method: "get",
    url,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    responseType: "arraybuffer",
  }).then((response) =>
    Buffer.from(response.data, "binary").toString("base64")
  );

export { request, api_root, downloadImage };
